module.exports = __webpack_public_path__ + "media/images/flower-dc0f08b7601165aa8c305f9b0ccba514.svg";